export default {
    ethnicity_10000: 'All',
};
